import React from 'react';
import { FormattedMessage } from 'react-intl';
import HubIcon from '@mui/icons-material/Hub';
import { routePathMap } from '../common/routes/routePaths';
import TIRouteProps from '../common/routes/TIRouteProps';
import { CollectorsPage } from './CollectorsPage';

export const collectorsPageRoute: TIRouteProps = {
  path: routePathMap.collectors,
  component: CollectorsPage,
  exact: true,
  title: <FormattedMessage id="tabs.collectors" />,
  icon: <HubIcon />
};
